export enum EDatePickerAllowedRange {
	PAST = 'past',
	FUTURE = 'future',
	ALL = 'all',
}
